export const CURRENCY_CODE_USD = 840;
export const CURRENCY_CODE_EUR = 978;
export const EUR = 'EUR';
export const USD = 'USD';
// сделано отдельной переменной, чтобы быстро найти все места использования
export const HARD_CODE_USD = 'USD';
